module.exports = __webpack_public_path__ + "static/img/Phoenix-Hargrave.ac94449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Phoenix-Hargrave.jpg
// module id = zza6
// module chunks = 0